import { GenericCollectionFactory } from "../_generics/GenericCollectionFactory";

export const LocationBillingDataStore = GenericCollectionFactory("LOCATION_BILLING_DATA_STORE", "name");